import { useContext } from 'react';
import { AuthService } from './AuthService/AuthService';

const useAPI = () => {
  const authService = useContext(AuthService);
  return authService.api;
};

export default useAPI;
